export const manualRequestFormConstants = {
  CREATE_MANUAL_ENTRY_SUCCESS: "CREATE_MANUAL_ENTRY_SUCCESS",
  VOLLMACHT_TAB_VALIDATION_SUCCESS: "VOLLMACHT_TAB_VALIDATION_SUCCESS",
  VOLLMACHT_TAB_QRCODE_SUCCESS: "VOLLMACHT_TAB_QRCODE_SUCCESS",
  VOLLMACHT_TAB_RESET_QR_CODE: "VOLLMACHT_TAB_RESET_QR_CODE",
  VOLLMACHT_SIGNING_STATUS_SUCCESS: "VOLLMACHT_SIGNING_STATUS_SUCCESS",
  GET_QES_PROVIDERS_SUCCESS: "GET_QES_PROVIDERS_SUCCESS",
  VOLLMACHT_SIGNED_SEPA_SUCCESS: "VOLLMACHT_SIGNED_SEPA_SUCCESS",
  VOLLMACHT_SIGNED_POA_SUCCESS: "VOLLMACHT_SIGNED_POA_SUCCESS",
  ZB_TEIL1_DOC_SUCCESS: "ZB_TEIL1_DOC_SUCCESS",
  ZB_TEIL2_DOC_SUCCESS: "ZB_TEIL2_DOC_SUCCESS",
  VOLLMACHT_SIGNED_POA_FAILURE: "VOLLMACHT_SIGNED_POA_FAILURE",
  VOLLMACHT_SIGNED_PROCESS_RESET: "VOLLMACHT_SIGNED_PROCESS_RESET",
  // Delete Vollmacht Loschen
  VOLLMACHT_LOSCHEN_SUCCESS: "VOLLMACHT_LOSCHEN_SUCCESS",
  DOWNLOAD_WIRTSCHAFTS_PDF_SUCCESS: "DOWNLOAD_WIRTSCHAFTS_PDF_SUCCESS",
  GET_RECHTSFORM_DATA_SUCCESS: "GET_RECHTSFORM_DATA_SUCCESS",
  GET_WIRTSCHAFTS_DATA_SUCCESS: "GET_WIRTSCHAFTS_DATA_SUCCESS",
  GET_STEUERBEFREIUNG_DATA_SUCCESS: "GET_STEUERBEFREIUNG_DATA_SUCCESS",
};

// Vollmacht Tab Constants
export const VollmachtFormConstants = {
  STEP_ONE_CONTENT:
    "Bitte scannen Sie den angezeigten QR-Code mit der Verimi-App auf Ihrem iPad",
  STEP_TWO_CONTENT:
    "In diesem Prozessschritt werden die Vollmacht und das SEPA-Mandat von Ihren Kund*innen via Verimi auf ihrem iPad bestätigt. Bitte folgen Sie den Schritten der über den QR Code geöffneten Anwendung.",
  STEP_THREE_LOCAL_CONTENT:
    "Sobald Ihr Kunde der Bevollmächtigung auf dem iPad zugestimmt hat, werden die Dokumente in der manuellen Eingabe angezeigt.",
  STEP_ONE_REMOTE_CONTENT: "Initiierung des Remote-Prozesses",
  STEP_TWO_REMOTE_CONTENT: "Remote-Identifizierungslink an User schicken",
  STEP_THREE_REMOTE_CONTENT:
    "Sobald Ihr Kunde der Bevollmächtigung zugestimmt hat, werden die Dokumente in der manuellen Eingabe angezeigt.",
  POA_STEP_THREE_CONTENT:
    "Sobald Ihr Kunde der Bevollmächtigung auf dem iPad zugestimmt hat, werden die Dokumente in der manuellen Eingabe angezeigt.",
};

// Halter Request Form Constants
export const halterRequestFormConstants = {
  ADDRESS_FIELDS_BLANK_INFO_NP:
    'Bitte vervollständigen Sie alle relevanten Informationen in der manuellen Eingabe, damit Sie den Vollmachtsprozess im Reiter "Vollmacht" starten können.',
  PPOA_VOLLMACHT_INFO:
    "Wenn Sie die Angaben bearbeiten wollen, wird die hinterlegte Dauervollmacht in dem Vorgang gelöscht und es muss eine neue Vollmacht erstellt werden.",
  PPOA_VOLLMACHT_DISCONNECT: "Wollen Sie die Angaben wirklich bearbeiten?",
  ZBT_TEIL2_OPTIONAL_TOOLTIP:
    "Die Angabe des Sicherheitscodes für die Zulassungsbescheinigung Teil II ist optional, wenn Halter und Kennzeichen gleich bleiben.",
};

export const VOLLMACHT_TOOLTIP_MESSAGES = {
  QES_COMPLETED_MESSAGE:
    "In der Volmacht erfasst. Zum Bearbeiten bitte Vollmacht loschen",
  VOLLMACHTRELEVANT: "Vollmachtsrelevant",
  QES_COMPLETED_TAB_TOOLTIP: "Angaben verifiziert",
  KUNDENNR_BEI_DER_ZULASSUNGSSTELLE_TOOLTIP:
    "Bitte tragen Sie hier, soweit vorhanden, ihre individuelle, zulassungsspezifisch vereinbarte Kundennummer ein.",
  EXTERNE_VORGANGSNUMMER:
    "Die externe Vorgangsnummer muss eine eindeutige Nummer sein. Falls nicht vorhanden, wird diese für Sie mit einem Klick auf 'Nein' generiert.",
};

export const KENNZEICHEN_TOOLTIP_MESSAGES = {
  KENNZEICHEN_SICHERHEITS_CODE_TOOLTIP:
    "Die Eingabe der Kennzeichen-Sicherheitscodes ist für bereits abgemeldete Fahrzeuge nicht erforderlich.",
};

export const personTypeOptions = [
  {
    label: "Natürliche Person",
    value: "naturliche",
  },
  {
    label: "Juristische Person",
    value: "juristische",
  },
];

export const yesORnoOptions = [
  {
    label: "Ja",
    value: "ja",
  },
  {
    label: "Nein",
    value: "nein",
  },
];

export const qesIdentOptions = [
  {
    label: "Local-Identifizierung",
    value: "LOCAL",
  },
  {
    label: "Remote-Identifizierung",
    value: "REMOTE",
  },
];

export const poaOptions = [
  {
    label: "Dauervollmacht",
    value: "Dauervollmacht",
  },
  {
    label: "Einzelvollmacht",
    value: "Einzelvollmacht",
  },
];

export const KENNZEICHEN_OPTIONS_0 = 0;
export const KENNZEICHEN_OPTIONS_1 = 1;
export const REGISTRATION_TYPE_UM = "UM";

export const kennzeichenZuweisenRadioOptions = [
  {
    label: "Nächstes freies Kennzeichen",
    value: KENNZEICHEN_OPTIONS_0,
  },
  {
    label: "Reserviertes Wunschkennzeichen",
    value: KENNZEICHEN_OPTIONS_1,
  },
];

export const vorgangsartOptions = [
  {
    label: "Neuzulassung",
    value: "NZ",
    isCreate: true,
  },
  {
    label: "Tageszulassung",
    value: "TZ",
    isCreate: true,
  },
  {
    label: "Außerbetriebsetzung",
    value: "AB",
    isCreate: true,
  },
  {
    label: "Ummeldung (alt)",
    value: "UM",
    isCreate: false,
  },
  {
    label: "Umschreibung (UG)",
    value: "UG",
    isCreate: true,
  },
  {
    label: "Wiederzulassung (WZ)",
    value: "WZ",
    isCreate: true,
  },
  {
    label: "Wiederzulassung (WG)",
    value: "WG",
    isCreate: true,
  },
  {
    label: "Namens- oder Adressänderung des Halters",
    value: "HA",
    isCreate: true,
  },
  {
    label: "Offen",
    value: "SO",
    isCreate: true,
  },
];
export const vorgangsartTextByType = [
  {
    label:
      "Fahrzeug ist bereits abgemeldet und soll auf selben Halter im selben Zulassungsbezirk zugelassen werden.",
    value: "WZ",
  },
  {
    label:
      "Fahrzeug ist bereits abgemeldet und soll auf einen neuen Halter im neuen Zulassungsbezirk zugelassen werden.",
    value: "WG",
  },
  {
    label: "Fahrzeug ist bereits zugelassen.",
    value: "UG",
  },
];
export const ZBTStaticOptions = [
  {
    label: "Adresse des Halters",
    value: "adresseDesHalters",
  },
  {
    label: "Individuelle Adresse eingeben",
    value: "individuelleAddresse",
  },
];
export const zbtNameTypeOptions = [
  {
    label: "Unternehmensname",
    value: "juristische",
  },
  {
    label: "Personenname",
    value: "naturliche",
  },
];

export const ZBTADDRESSFIELDS = {
  zbt1AddressType: {
    unternehmen: "zbt1Unternehmen",
    strasse: "zbt1Strasse",
    stadt: "zbt1Stadt",
    hausnummer: "zbt1Hausnummer",
    postleitzahl: "zbt1Postleitzahl",
  },
  zbt2AddressType: {
    unternehmen: "zbt2Unternehmen",
    strasse: "zbt2Strasse",
    stadt: "zbt2Stadt",
    hausnummer: "zbt2Hausnummer",
    postleitzahl: "zbt2Postleitzahl",
  },
};
export const ZBTADDRESSFIELDSPOA = {
  zbt1AddressType: {
    unternehmen: "zbt1Unternehmen",
    strasse: "zbt1Strasse",
    stadt: "zbt1Stadt",
    houseNummer: "zbt1Hausnummer",
    postleitzahl: "zbt1Postleitzahl",
  },
  zbt2AddressType: {
    unternehmen: "zbt2Unternehmen",
    strasse: "zbt2Strasse",
    stadt: "zbt2Stadt",
    houseNummer: "zbt2Hausnummer",
    postleitzahl: "zbt2Postleitzahl",
  },
};

export const ZBT1ALLATTRIBUTES = [
  "zbt1ZustellungType",
  "zbt1AddressType",
  "zbt1IndividualAddresseType",
  "zbt1PersonVorname",
  "zbt1PersonNachname",
  "zbt1Unternehmen",
  "zbt1Strasse",
  "zbt1Stadt",
  "zbt1Hausnummer",
  "zbt1Postleitzahl",
];

export const ZBT2ALLATTRIBUTES = [
  "zbt2ZustellungType",
  "zbt2AddressType",
  "zbt2IndividualAddresseType",
  "zbt2PersonVorname",
  "zbt2PersonNachname",
  "zbt2Unternehmen",
  "zbt2Strasse",
  "zbt2Stadt",
  "zbt2Hausnummer",
  "zbt2Postleitzahl",
];

export const IndividualAddressFieldsZB1 = [
  { fieldId: "zbt1Strasse", fieldLabel: "Straße", maxLength: 40 },
  { fieldId: "zbt1Hausnummer", fieldLabel: "Nummer", maxLength: 25 },
  { fieldId: "zbt1Postleitzahl", fieldLabel: "Postleitzahl", maxLength: 10 },
  { fieldId: "zbt1Stadt", fieldLabel: "Stadt", maxLength: 40 },
];

export const IndividualAddressFieldsZB2 = [
  { fieldId: "zbt2Strasse", fieldLabel: "Straße", maxLength: 40 },
  { fieldId: "zbt2Hausnummer", fieldLabel: "Nummer", maxLength: 25 },
  { fieldId: "zbt2Postleitzahl", fieldLabel: "Postleitzahl", maxLength: 10 },
  { fieldId: "zbt2Stadt", fieldLabel: "Stadt", maxLength: 40 },
];

export const IndividualAddressFieldsZB1POA = [
  { fieldId: "strasse", fieldLabel: "Straße", maxLength: 40 },
  { fieldId: "houseNummer", fieldLabel: "Nummer", maxLength: 25 },
  { fieldId: "postleitzahl", fieldLabel: "Postleitzahl", maxLength: 10 },
  { fieldId: "stadt", fieldLabel: "Stadt", maxLength: 40 },
];

export const IndividualAddressFieldsZB2POA = [
  { fieldId: "strasse", fieldLabel: "Straße", maxLength: 40 },
  { fieldId: "houseNummer", fieldLabel: "Nummer", maxLength: 25 },
  { fieldId: "postleitzahl", fieldLabel: "Postleitzahl", maxLength: 10 },
  { fieldId: "stadt", fieldLabel: "Stadt", maxLength: 40 },
];

export const verwendungFahrzeugOptions = [
  {
    label: "",
    value: "",
  },
  {
    label: "Selbstfahrermietfahrzeug",
    value: "S",
  },
  // Commenting these options for now might be used in upcoming stories

  // {
  //   label: "Krankenwagen",
  //   value: formConstants.Krankenwagen,
  // },
  // {
  //   label: "Linienbus",
  //   value: formConstants.Linienbus,
  // },
  // {
  //   label: "Mietfahrzeug",
  //   value: formConstants.Mietfahrzeug,
  // },
  // {
  //   label: "Taxi",
  //   value: formConstants.Taxi,
  // },
  // {
  //   label: "sonstige Verwendung",
  //   value: formConstants["sonstige Verwendung"],
  // },
];
export const inspectionTypeOptions = [
  {
    label: "Hauptuntersuchung (HU)",
    value: "HU",
  },
  {
    label: "Sicherheitsüberprüfung (SP)",
    value: "SP",
  },
];
export const deRegistrationTypeOptions = [
  {
    label: "Fahrzeug wird verschrottet",
    value: "0",
  },
  {
    label: "keine Verwertung",
    value: "1",
  },
  {
    label: "Fahrzeug wird exportiert",
    value: "2",
  },
];
export const steuerzahlweiseOptions = [
  {
    label: "",
    value: "",
  },
  {
    label: "jährlich",
    value: "jährlich",
  },
  {
    label: "Halbjaehrlich",
    value: "halbjaehrlich",
  },
  {
    label: "Vierteljaehrlich",
    value: "vierteljaehrlich",
  },
  {
    label: "Steuerfrei",
    value: "steuerfrei",
  },
];
export const zbAddressZustellungOptions = [
  {
    label: "Versandadresse",
    value: "VERSAND",
  },
  {
    label: "Abholung durch",
    value: "ABHOLUNG",
  },
];
export const documentNames = {
  dauervollmacht: { fileName: "Vollmacht", id: "1" },
  sepaMandat: { fileName: "SEPA-Mandat", id: "2" },
};

export const PPOAdocumentNames = {
  dauervollmacht: { fileName: "Dauervollmacht", id: "1" },
  sepaMandat: { fileName: "SEPA-Mandat", id: "2" },
  addressDocument: { fileName: "Adressnachweis", id: "3" },
};

export const rrcdocumentNames = {
  addressDocument: { fileName: "Adressnachweis", id: "1" },
};

export const ZBGENERICERROR = "Bitte treffen Sie eine Auswahl.";

export const zb1zb2InfoMessage = `Zur Anzeige der angelegten Adressen, speichern Sie bitte den gesamten Vorgang mit dem Button "Speichern & Prüfen".`;

// Gender Dropdown Options
export const GeschlechtOptions = [
  {
    label: "männlich",
    value: "m",
  },
  {
    label: "weiblich",
    value: "w",
  },
  {
    label: "divers",
    value: "d",
  },
  {
    label: "nicht definiert",
    value: "x",
  },
];
export const QESSupportDataRemoteIdent = [
  {
    label: "Method",
    key: "qesType",
  },
  {
    label: "ID Used",
    key: "identDocument",
  },
  {
    label: "Basket ID",
    key: "basketId",
  },
  {
    label: "Sign Process ID",
    key: "signProcessId",
  },
];
export const QESSupportDataLocalIdent = [
  {
    label: "Method",
    key: "qesType",
  },
  {
    label: "ID Used",
    key: "identDocument",
  },
  {
    label: "Process ID",
    key: "processId",
  },
];

export const PREFILLED_DOCUMENTS_TITLE = "Dokumentendownload";
export const PREFILLED_DOCUMENTS_DESCRIPTION =
  "Zum Zweck der digitalen Signatur erhalten Sie durch den Download die vorausgefüllte Zulassungsvollmacht mit Halterdaten, sowie das SEPA-Mandat.";
export const PREFILLED_DOCUMENTS_FORM_ERROR =
  'Bitte füllen Sie alle Pflichtfelder und klicken Sie auf "Speichern und Prüfen", um Ihre Vollmachtsdokumente herunterzuladen.';
export const PREFILLED_DOCUMENTS_BUTTON_LABEL = "Downloaden";

export const PREFILLED_DOCUMENTS_SUCCESS_DOWNLOAD = "Download war erfolgreich.";

export const PPOA_DISCONNECTION_ATTRIBUTE = [
  "dauervollmacht",
  "sepaMandat",
  "unterzeichnungsprozess",
  "dauervollmachtId",
];

export const SIGNATURE_PROCESS_DOCUMENTS_EMAIL =
  "Externen Signaturprozess starten";
export const SIGNATURE_PROCESS_DOCUMENTS_EMAIL_JP_DESCRIPTION =
  "Externe digitale Signatur für die Zulassungsvollmacht und das SEPA-Mandat. Die Dauervollmacht wird automatisch in die Vollmachtsdatenbank übertragen.";
export const SIGNATURE_PROCESS_DOCUMENTS_EMAIL_NP_DESCRIPTION =
  "Externen Signaturprozess starten Externe digitale Signatur für die Zulassungsvollmacht und das SEPA-Mandat.";
export const SIGNATURE_PROCESS_DOCUMENTS_BUTTON_LABEL =
  "Signaturprozess anfordern";

export const VOLLMACHT_FILE_UPLOAD = "Dokumentenupload";
export const VOLLMACHT_FILE_UPLOAD_DESCRIPTION =
  "Hier können Sie Ihre digital signierten (z.B. durch Verimi) Vollmachtsdokumente als PDF hochladen.";
export const VOLLMACHT_UPLOADED_FILE_DETAIL_VIEW = "Ausgewählte Vollmacht";

// Email Fields
export const EMAIL_ROW_COLUMNS = [
  { id: "vorname", label: "Vorname", size: "2" },
  { id: "nachname", label: "Nachname", size: "2" },
  { id: "emailadresse", label: "Emailadresse", size: "2" },
  { id: "bvVorname", label: "BV-Vorname", size: "1.7" },
  { id: "bvNachname", label: "BV-Nachname", size: "1.7" },
  { id: "bvEmailadresse", label: "BV-Emailadresse", size: "1.7" },
];

export const ZIP_FILE_VAILADATION =
  "Bitte wählen Sie eine gültige ZIP-Datei aus.";

export const FILE_SIZE_VALIDATION_20MB = "Die Datei ist größer als 20 MB.";

export const FILE_SIZE_VALIDATION_10MB = "Die Datei ist größer als 10 MB.";

export const ADDRESS_PROOF_DESCRIPTION =
  "Bitte laden Sie einen erlaubten und gültigen Adressnachweis hoch.";

export const ADDRESS_PROOF_COMPANY_DESCRIPTION =
  "Bitte laden Sie einen gültigen Adressnachweis hoch.";

export const ADDRESS_PROOF_COMPANY_EXAMPLES_TITLE =
  "Zulässige Nachweise sind zum Beispiel:";

export const ADDRESS_PROOF_COMPANY_EXAMPLES_LIST =
  "Gewerbeanmeldung oder Gewerbeummeldung, Steuerbescheid oder Schreiben des Finanzamts, Meldebescheinigung, Handelsregisterauszug";

export const ADDRESS_PROOF_CONFIRMATION_LABEL =
  "Ich habe die Halteradresse anhand eines amtlichen Dokuments (z. B. Personalausweis) geprüft und bestätige die Übereinstimmung.";

export const ADDRESS_PROOF_RESET_INFO_MESSAGE =
  "Achtung! Wenn Sie auf 'Nein' wechseln, wird der Vollmachtsprozess neu gestartet.";

export const PDF_ALLOWED_EXTENSION = ["pdf"];

export const MAX_10MB_FILE_SIZE = 10485760; // 10 MB in bytes

export const FILE_EXCEEDS_10MB_ERROR = "Die Datei ist größer als 10 MB.";

export const FILE_PDF_FORMAT_ERROR = "Es sind nur PDFs erlaubt.";

export const vollmachtFileNamesMapping = {
  // label names mapped with API attribute names
  "SEPA-Mandat": "sepaMandat",
  Dauervollmacht: "dauervollmacht",
  Einzelvollmacht: "dauervollmacht",
};

export const PREVIEW = "PREVIEW";

export const DOWNLOAD = "DOWNLOAD";

export const IMAGE_FILE_PNG_TYPE = "image/png";

export const PDF_FILE_TYPE = "application/pdf";

export const NO_CONTENT_FILE_DOWNLOAD =
  "Dieses Dokument ist nicht im KBA-Bescheid enthalten.";

export const SUPPORT_QES_LOCAL_IDENT = "Local Ident";

export const CATEGORY_DEF = [
  {
    key: "NZ",
    header: "Neuzulassung/Tageszulassung",
    message: "CSV-Datei (UTF-8) mit Fahrzeugdaten auswählen.",
  },
  {
    key: "UM",
    header: "Umschreibung (UG)/Wiederzulassung (WZ), (WG)",
    message: "CSV-Datei (UTF-8) mit Fahrzeugdaten auswählen.",
    errorMessage: "Error here",
  },
  {
    key: "AB",
    header: "Außerbetriebsetzung",
    message: "CSV-Datei (UTF-8) mit Fahrzeugdaten auswählen.",
  },
];

export const CATEGORY_OPTIONS = [
  {
    label: "Neuzulassung/Tageszulassung",
    value: "nz-tz",
    fileType: "csv",
  },
  {
    label: "Umschreibung (UG)/Wiederzulassung (WZ), (WG)",
    value: "ug-wg-wz",
    fileType: "csv",
  },
  {
    label: "Außerbetriebsetzung",
    value: "ab",
    fileType: "csv",
  },
  {
    label: "CSV Anleitung",
    value: "csv-anleitung",
    fileType: "pdf",
  },
];

export const VEHICLE_LIST_FORMAT_TEMPLATE_INFO =
  "Hier finden Sie die Formatvorlagen zur Vorbereitung der Fahrzeugliste(n):";

export const PREPARING_YOUR_CSV_FILE = "CSV Datei(en) vorbereiten";

export const VEHICLE_LIST_TEMPLATE_DOWNLOAD_LABEL = "Vorlagendownload";

export const CATEGORY_KEY_MAP = {
  NZ: "NZ-TZ",
  UM: "UG-WG-WZ",
  AB: "AB",
  UG: "UG",
  WG: "WG",
};

export const SAMMELANTRAG = "Sammelantrag";
export const LOSCHEN = "Löschen";
export const CSV_HOCHLADEN = "CSV hochladen";
export const FILE_UPLOAD_ERROR_MSG =
  "Bitte wählen Sie eine gültige CSV-Datei aus.";

export const SIGNING_PROCESSING_TYPE = {
  QES: "Qes",
  FILE_UPLOAD: "FileUpload",
};

export const VollmachtRadioSteps = {
  QES_SECTION_TITLE: "Wie möchten Sie die Vollmacht unterzeichnen?",
  QES_STEP_1_TITLE: "Direkt signieren",
  QES_STEP_1_SUB_TITLE:
    "Starten Sie den Signaturvorgang für den Halter direkt in MyDigitalCar. Die ausgewählte Person erhält anschließend einen Link des Signaturanbieters zur Identifizierung und Unterzeichnung.",
  QES_STEP_2_TITLE: "Extern elektronisch signieren und hochladen",
  QES_STEP_2_SUB_TITLE:
    "Laden Sie die vorbefüllte Vollmacht herunter, signieren Sie diese über Ihren eigenen QES-Anbieter und laden Sie das signierte Dokument anschließend wieder hoch.",
};
